/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceStatusFilter
 */
export interface PriceStatusFilter {
    /**
     * 
     * @type {boolean}
     * @memberof PriceStatusFilter
     */
    approved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PriceStatusFilter
     */
    preliminary?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PriceStatusFilter
     */
    readonly isEmpty?: boolean;
}

/**
 * Check if a given object implements the PriceStatusFilter interface.
 */
export function instanceOfPriceStatusFilter(value: object): value is PriceStatusFilter {
    return true;
}

export function PriceStatusFilterFromJSON(json: any): PriceStatusFilter {
    return PriceStatusFilterFromJSONTyped(json, false);
}

export function PriceStatusFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceStatusFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'approved': json['approved'] == null ? undefined : json['approved'],
        'preliminary': json['preliminary'] == null ? undefined : json['preliminary'],
        'isEmpty': json['isEmpty'] == null ? undefined : json['isEmpty'],
    };
}

export function PriceStatusFilterToJSON(json: any): PriceStatusFilter {
    return PriceStatusFilterToJSONTyped(json, false);
}

export function PriceStatusFilterToJSONTyped(value?: Omit<PriceStatusFilter, 'isEmpty'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approved': value['approved'],
        'preliminary': value['preliminary'],
    };
}

